module.exports = __webpack_public_path__ + "static/media/glassolution.ade44505.jpg";